var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFailedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "#FFD9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6927 7.30728C17.2831 6.89757 16.6188 6.89757 16.2091 7.30728L12.5 11.0164L8.7909 7.30728C8.38127 6.89757 7.71698 6.89757 7.30728 7.30728C6.89757 7.71698 6.89757 8.38119 7.30728 8.7909L11.0164 12.5L7.30728 16.2091C6.89757 16.6188 6.89757 17.283 7.30728 17.6927C7.51213 17.8975 7.78063 18 8.04906 18C8.31755 18 8.58605 17.8976 8.79083 17.6927L12.4999 13.9836L16.209 17.6927C16.4139 17.8975 16.6824 18 16.9508 18C17.2193 18 17.4878 17.8976 17.6927 17.6927C18.1024 17.283 18.1024 16.6188 17.6927 16.2091L13.9836 12.5L17.6927 8.7909C18.1024 8.38119 18.1024 7.71698 17.6927 7.30728Z",
    fill: "#9F0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailedIcon);
export default __webpack_public_path__ + "static/media/failed-icon.ee140d2cc7e36b5b340d06f4580db14a.svg";
export { ForwardRef as ReactComponent };